import { Icon, Style } from "ol/style";
import IconAnchorUnits from "ol/style/IconAnchorUnits";

import normalGeneric from "../../../assets/icons/map_pointers/generic/green_pin_feeler.svg";
import selectedGeneric from "../../../assets/icons/map_pointers/generic/selected_pin_feeler.svg";

import normalCattle from "../../../assets/icons/map_pointers/cattle/ic_cow_border.png";
import selectedCattle from "../../../assets/icons/map_pointers/cattle/ic_cow_selected.png";

import normalHive from "../../../assets/icons/map_pointers/hive/ic_hive_border.png";
import selectedHive from "../../../assets/icons/map_pointers/hive/ic_hive_selected.png";

export default class IotIcons {

    genericIcon: { [key: string]: Style } = {}
    hiveIcon: { [key: string]: Style } = {}
    cattleIcon: { [key: string]: Style } = {}

    generic = {
        selectedMapStyle: normalGeneric,
        selectedDefaultStyle: selectedGeneric,
        normalDefaultStyle: normalGeneric,
        hoveredDefaultStyle: normalGeneric
    }
    hive = {
        selectedMapStyle: normalHive,
        selectedDefaultStyle: selectedHive,
        normalDefaultStyle: normalHive,
        hoveredDefaultStyle: normalHive
    }
    cattle = {
        selectedMapStyle: normalCattle,
        selectedDefaultStyle: selectedCattle,
        normalDefaultStyle: normalCattle,
        hoveredDefaultStyle: normalCattle
    }

    allIcon = [this.genericIcon, this.hiveIcon, this.cattleIcon];

    allIconPath = [this.generic, this.hive, this.cattle];
    allKey = [
        "selectedMapStyle",
        "selectedDefaultStyle",
        "normalDefaultStyle",
        "hoveredDefaultStyle"
    ]

    constructor() {

        this.allIcon.forEach((c, i) => {
            this.allKey.forEach(k => {
                switch (k) {
                    case "selectedMapStyle":
                        c["selectedMapStyle"] = new Style({
                            image: new Icon({
                                anchor: [0.5, 40],
                                anchorXUnits: IconAnchorUnits.FRACTION,
                                anchorYUnits: IconAnchorUnits.PIXELS,
                                src: this.allIconPath[i]["selectedMapStyle"],
                                scale: 0.5,
                            }),
                        })
                        break;
                    case "selectedDefaultStyle":

                        c["selectedDefaultStyle"] = new Style({
                            image: new Icon({
                                anchor: [0.5, 40],
                                anchorXUnits: IconAnchorUnits.FRACTION,
                                anchorYUnits: IconAnchorUnits.PIXELS,
                                src: this.allIconPath[i]["selectedDefaultStyle"],
                                scale: 0.5,
                            }),
                        });

                        break;
                    case "normalDefaultStyle":
                        c["normalDefaultStyle"] = new Style({
                            image: new Icon({
                                scale: 0.5,
                                anchor: [0.48, 40],
                                anchorXUnits: IconAnchorUnits.FRACTION,
                                anchorYUnits: IconAnchorUnits.PIXELS,
                                src: this.allIconPath[i]["normalDefaultStyle"],
                            }),
                        });
                        break;
                    case "hoveredDefaultStyle":
                        c["hoveredDefaultStyle"] = new Style({
                            image: new Icon({
                                // scale: 1,
                                scale: 0.7,
                                anchor: [0.48, 40],
                                anchorXUnits: IconAnchorUnits.FRACTION,
                                anchorYUnits: IconAnchorUnits.PIXELS,
                                src: this.allIconPath[i]["hoveredDefaultStyle"],
                            }),
                        });
                        break;
                    default:
                        c["normalDefaultStyle"] = new Style({
                            image: new Icon({
                                scale: 0.5,
                                anchor: [0.48, 40],
                                anchorXUnits: IconAnchorUnits.FRACTION,
                                anchorYUnits: IconAnchorUnits.PIXELS,
                                src: this.allIconPath[i]["normalDefaultStyle"],
                            }),
                        });
                        break;
                }
            })
        })

    }


    getDefaultSelectedIcon(type?: string) {
        let v;
        switch (type) {
            case "HIVE":
                v = this.hiveIcon["selectedDefaultStyle"];
            break;
            case "CATTLE":
                v = this.cattleIcon["selectedDefaultStyle"];
            break;
            case "GENERIC":
                v = this.genericIcon["selectedDefaultStyle"];
            break;
            default:
                v = this.genericIcon["selectedDefaultStyle"]
                break;
        }
        return v;
    }

    getDefaultHoveredIcon(type?: string) {
        let v;
        switch (type) {
            case "HIVE":
                v = this.hiveIcon["hoveredDefaultStyle"];
            break;
            case "CATTLE":
                v = this.cattleIcon["hoveredDefaultStyle"];
            break;
            case "GENERIC":
                v = this.genericIcon["hoveredDefaultStyle"];
            break;
            default:
                v = this.genericIcon["hoveredDefaultStyle"];
                break;
        }

        return v;
    }

    getDefaultNormalIcon(type?: string) {
        let v;
        switch (type) {
            case "HIVE":
                v = this.hiveIcon["normalDefaultStyle"];
            break;
            case "CATTLE":
                v = this.cattleIcon["normalDefaultStyle"];
            break;
            case "GENERIC":
                v = this.genericIcon["normalDefaultStyle"];
            break;
            default:
                v = this.genericIcon["normalDefaultStyle"]
                break;
        }
        return v;
    }
    getDefaultMapIcon(type?: string) {
        let v;
        switch (type) {
            case "HIVE":
                v = this.hiveIcon["selectedMapStyle"];
            break;
            case "CATTLE":
                v = this.cattleIcon["selectedMapStyle"];
            break;
            case "GENERIC":
                v = this.genericIcon["selectedMapStyle"];
            break;
            default:
                v = this.genericIcon["selectedMapStyle"]
                break;
        }
        return v;
    }


}
